import { Injectable } from '@angular/core';
import { AllModulePermissionsResponse, AssignedRoleCountResponse, ListRolePayload, ListRolePermissionResponse, RoleNameListResponse, RolePermission, RolePermissionPayload, RolePermissionResponse, SystemRolePermission, UpdateRoleParams } from '../../state/models/rolePermission.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class RolePermissionService {

  private readonly apiUrl = `${environment.roleEndpoint}/api/role-permission`;

  constructor(private readonly apiService: ApiService) { }

  getRolePermission(roleId: number): Promise<RolePermissionResponse> {
    return this.apiService.get<RolePermissionResponse>(`${this.apiUrl}/${roleId}`);
  }

  createRole(payload: RolePermissionPayload): Promise<RolePermissionResponse> {
    return this.apiService.post<RolePermissionResponse>(`${this.apiUrl}/`, payload);
  }

  listRoles(payload?: ListRolePayload, page = 1, limit = 10): Promise<ListRolePermissionResponse> {
    return this.apiService.post<ListRolePermissionResponse>(`${this.apiUrl}/list?page=${page}&limit=${limit}`, payload || {});
  }

  roleNames(): Promise<RoleNameListResponse> {
    return this.apiService.get<RoleNameListResponse>(`${this.apiUrl}/roles/active`);
  }

  allModulePermissions(): Promise<AllModulePermissionsResponse> {
    return this.apiService.get<AllModulePermissionsResponse>(`${this.apiUrl}/permissions`);
  }

  getSystemRolePermissions(): Promise<SystemRolePermission> {
    return this.apiService.get<SystemRolePermission>(`${this.apiUrl}/systemRolePermissions`);
  }

  getRoleById(id: number): Promise<{ data: RolePermission }> {
    return this.apiService.get<{ data: RolePermission }>(
      `${this.apiUrl}/${id}`
    );
  }

  updateRole(params: UpdateRoleParams): Promise<RolePermissionResponse> {
    return this.apiService.put<RolePermissionResponse>(
      `${this.apiUrl}/${params.id}`, // ID in URL
      params.payload // Only update fields in body
    );
  }

  deleteRole(id: number): Promise<RolePermissionResponse> {
    return this.apiService.delete<RolePermissionResponse>(
      `${this.apiUrl}/${id}`
    );
  }

  assignedRoleCount(id: number): Promise<AssignedRoleCountResponse > {
    return this.apiService.get<AssignedRoleCountResponse >(
      `${this.apiUrl}/alert-role-modification-popup/${id}`
    );
  }
}
